export default __webpack_public_path__ + "static/media/icon4.8cba0abe.svg";